

import { ArrowRight, CheckCircle, Star } from 'lucide-react';
import '../../../../../assets/css/subscreens/customer/dashboard/apphome/topworkers/TopWorkers.css';
import { useWorkerProfileContext } from '../../../../../context/workerprofilecontext/WorkerProfileContext';
import React, { useEffect, useState ,useContext} from 'react';
import AppContext from '../../../../../context/AppContext';
import axios from 'axios';


const getInitials = (name) =>
  name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);

const TopWorkers = () => {
const {baseUrl, authToken, baseUrlForFile} = useContext(AppContext);
  // fetch workers
  const [workers, setWorkers] = useState([]);
useEffect(() => {
  if (!authToken) {
    console.log("Token not available yet");
    return;
  }

const viewTopWorkers = async () => {
  try {

    console.time("Top Workers API");
  

    const response = await axios.get(
      `${baseUrl}/customer/viewtopworkers`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );

    console.timeEnd("Top Workers API");
      console.log(response.data.workers);

    setWorkers(response.data.workers);

  } catch (err) {
    console.log(err);
  }
};

  viewTopWorkers();

}, [authToken, baseUrl]);

  // ✅ Context
  const { setSelectedWorkerProfile } = useWorkerProfileContext();

  return (
    <section className="tw-section">

      {/* Header */}
      <div className="tw-header">
        <h2 className="tw-title">Top Responders</h2>
       
      </div>

      {/* Grid */}
      <div className="tw-grid">
        {workers.map(w => (
  <div
    key={w.id}
    className="tw-card"
    onClick={() => {
      setSelectedWorkerProfile(w);
  
    }}
  >
<div
 className="tw-card__avatar"
 style={{ background:'#dbeafe', color:'#1d4ed8' }}
>

{w.ProfileImage ? (

<img
 src={w.ProfileImage}
 alt={w.fullName}
 className="tw-card__image"
/>

) : (

<span className="tw-card__initials">
{
  w.fullName
    ? w.fullName
        .trim()
        .split(" ")
        .slice(0, 2)
        .map(word => word.charAt(0))
        .join("")
        .toUpperCase()
    : "NA"
}
</span>

)}

</div>

    <div className="tw-card__info">
      <div className="tw-card__name-row">
        <span className="tw-card__name">{w.fullName}</span>
        <CheckCircle size={15} className="tw-card__verified"/>
      </div>

      <span className="tw-card__profession">{w.selectservice}</span>

      <div className="tw-card__rating">
        <Star size={13} fill="#f59e0b" color="#f59e0b"/>
<span>
  {Number(w.whreviews_avg_workerrating || 0).toFixed(1)}
</span>      </div>
    </div>
  </div>
))}
      </div>

    </section>
  );
};

export default TopWorkers;